import React from 'react';

const SvgGg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GG_svg__b" fill="#fff">
        <use xlinkHref="#GG_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#E8112D"
        mask="url(#GG_svg__b)"
        d="M10.667 0h6.667v20h-6.667z"
      />
      <path fill="#E8112D" mask="url(#GG_svg__b)" d="M0 6.667h28v6.667H0z" />
      <g mask="url(#GG_svg__b)" fill="#F9DD16">
        <path d="M13.334 2.667h1.333v14.667h-1.333z" />
        <path d="M14 16l1.333 1.333h-2.666zM6.667 9.334h14.667v1.333H6.667zM14 4l1.333-1.333h-2.666z" />
        <path d="M8 10L6.667 8.667v2.666zM20 10l1.333-1.333v2.666z" />
      </g>
    </g>
  </svg>
);

export default SvgGg;
